import React, { PropTypes } from 'react';
import Radio from '../../common/Radio/Radio';

class PaymentTypeSelector extends React.Component {
  render () {
    const {type, onChange} = this.props;

    return (
      <div className="payment-type-selector">
        <Radio label="Online / karta" checked={type == 'online'} onChange={onChange.bind(this, 'online')}/>
      <Radio label="Gotówka przy odbiorze" checked={type == 'cash'} onChange={onChange.bind(this, 'cash')} />
      </div>
    );
  }
}

PaymentTypeSelector.propTypes = {
  type: React.PropTypes.string,
  onChange: PropTypes.func
};

export default PaymentTypeSelector;



// WEBPACK FOOTER //
// ./src/components/common/PaymentTypeSelector/PaymentTypeSelector.js